<div
  class="active-subscription-container horizontal-center back-btn"
  (click)="disabled($event)"
  (keydown)="handleKeydown($event)"
  (mousedown)="disabled($event)"
  (mouseup)="disabled($event)"
>
  <div class="active-subscription-modal">
    <h2 [style]="'fontSize.36' | translate">
      {{ "tvod_payment_not_allowed_title" | translate }}
    </h2>
    <p
      [innerHTML]="'tvod_payment_not_allowed_msg' | translate"
      [style]="'fontSize.28' | translate"
    ></p>
    <div
      class="actions horizontal-as horizontal-focusable-container generic-dialog"
    >
      <app-icon-button
        [label]="'error.ok' | translate"
        [isUppercase]="false"
        [customClass]="'action-button'"
        (clicked)="onClose()"
      ></app-icon-button>
    </div>
  </div>
</div>
